// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XZVe","colMin":"styles_colMin__1gc1v"};